var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","rel":"noopener","href":_vm.privacyPolicyUrl}},[_vm._t("default",function(){return [_vm._v("Privacy Policy")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }